import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: Array<ClassValue>) {
  return twMerge(clsx(inputs));
}

const pad2 = (value: number) => String(value).padStart(2, '0');

// Safely format to YYYY-MM-DDThh:mm for datetime-local
export const formatDateForInput = (dateString: string | unknown): string => {
  if (typeof dateString !== 'string' || !dateString) return '';
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '';

  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(
    date.getDate()
  )}T${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
};

// Convert YYYY-MM-DDThh:mm to dd/mm/yyyy hh:mm
export const formatDateForDisplay = (dateString: string | unknown): string => {
  const input = formatDateForInput(dateString);
  return input ? input.replace('T', ' ') : '';
};

// Convert YYYY-MM-DDThh:mm to ISO string
export const dateTimeLocalToISOString = (dateTimeLocal: string): string => {
  if (!dateTimeLocal) return '';
  const date = new Date(dateTimeLocal);
  if (Number.isNaN(date.getTime())) return '';
  return date.toISOString();
};

export const normalizeToISOString = (dateString: string): string => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return dateString;
  return date.toISOString();
};

/** Returns a UTC timestamp string safe for use in file names, e.g. "2026-05-13T09-59-00-000Z". */
export const formatTimestampForFilename = (date = new Date()): string =>
  date.toISOString().replace(/[:.]/gu, '-');

/**
 *
 * Boundaries for lightness & saturation are set so all colors look "similar"
 *
 * @example
 * generateHSLColor() // 'hsl(200, 50%, 55%)'
 * @returns {string} HSL color
 */
export function generateHSLColor() {
  const minSaturation = 0.5;
  const maxSaturation = 0.8;
  const minLightness = 0.5;
  const maxLightness = 0.6;

  const hue = Math.floor(Math.random() * 360);

  const saturation = Math.floor(
    (Math.random() * (maxSaturation - minSaturation) + minSaturation) * 100
  );
  const lightness = Math.floor(
    (Math.random() * (maxLightness - minLightness) + minLightness) * 100
  );
  const color = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  return color;
}

export const isWeekend = (dateString: string) => {
  const day = new Date(dateString).getDay();
  return day === 0 || day === 6;
};
